import {useSelector} from 'react-redux';
import Selector from '../../../../../../../selectors/pages/home/facebook_boost';
import ModalsLib from '../../../../../../../lib/modals';
import {navigate} from '../../../../../../../utils/navigation';
import WhiteButton from '../../../../../../components/white-button';

export default () => {
    const {isAuth} = useSelector(Selector);

    return (
        <div className="new_slide_20 tyl--slide">
            <div className="logotype">
                <svg width="35" height="42" viewBox="0 0 35 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M34.2033 28.2536C34.7344 28.2536 35 28.8693 35 30.1009C35 32.6727 33.8316 35.1721 31.4947 37.599C29.1578 39.9897 26.3075 41.2031 22.9439 41.2393C20.5716 41.2393 17.8275 40.2794 14.7117 38.3596C12.481 40.7865 9.70157 42 6.37329 42C4.17805 42 2.56702 41.4386 1.54021 40.3157C0.513404 39.1928 0 37.7076 0 35.8603C0 34.0129 0.655033 32.6365 1.9651 31.7309C3.31057 30.7891 5.01012 30.3182 7.06373 30.3182C8.16136 30.3182 9.18816 30.3726 10.1442 30.4812C10.1442 26.0621 10.6222 21.7516 11.5781 17.5498C10.4097 16.934 9.40061 16.2458 8.55083 15.4851C7.73647 14.7245 7.32929 14.1268 7.32929 13.6921C7.32929 12.533 7.57714 11.9534 8.07284 11.9534C8.78098 11.9534 9.50683 12.1708 10.2504 12.6054C11.0293 13.0039 11.8614 13.3118 12.7466 13.5291C14.9418 7.04528 17.9514 2.86158 21.7754 0.978008C23.1209 0.326002 24.5372 0 26.0243 0C31.6186 0 34.4158 2.4088 34.4158 7.22639C34.4158 9.9793 33.4067 12.3519 31.3885 14.3441C28.5913 17.097 24.3424 18.5459 18.6419 18.6908C18.2524 21.7335 18.0577 25.3376 18.0577 29.5032C18.0577 30.5175 17.9337 31.6585 17.6859 32.9263C18.9251 33.5783 20.129 34.1759 21.2974 34.7193C22.4659 35.2626 23.8999 35.5343 25.5994 35.5343C26.4846 35.5343 27.352 35.1539 28.2018 34.3933C29.087 33.6326 29.9014 32.7995 30.6449 31.8939C31.4239 30.9884 32.1143 30.1552 32.7162 29.3946C33.3182 28.6339 33.8139 28.2536 34.2033 28.2536ZM25.9181 5.32471C22.9439 5.32471 20.784 8.22251 19.4385 14.0181C21.9879 13.8008 24.13 13.0763 25.865 11.8448C27.6353 10.577 28.5205 9.30919 28.5205 8.0414C28.5205 6.23027 27.653 5.32471 25.9181 5.32471ZM5.15175 36.2406C5.18715 37.2549 5.87759 37.762 7.22307 37.762C8.56854 37.762 9.41831 36.9651 9.77238 35.3713C8.78098 34.8642 7.96662 34.6106 7.32929 34.6106C5.913 34.6106 5.18715 35.1539 5.15175 36.2406Z"
                        fill="currentColor"
                    />
                </svg>
            </div>

            <div className="slide-content">
                <div className="slide-info">
                    <div className="slide-title">
                        Test<br/>Your <span>Luck</span>
                    </div>
                    <div className="slide-text">
                        If you're unlucky today - test your luck with Lucksy!
                    </div>
                </div>
                <div className="slide-button" onClick={e => {
                    if(isAuth)
                        navigate('/testyourluck');
                    else
                        ModalsLib.open('signin');
                }}>
                    How it works?
                    <div className="arrow">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0467 6.38065L8.00001 2.33398L3.95334 6.38065" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M8.00002 13.6673V2.44727" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    )
}